import { Action } from '@ngrx/store';
import { AddressQueryParameters } from '@quorum/models/xs-query';
import { Address } from '@quorum/models/xs-resource';

export enum AddressEntityActionTypes {
  GetAddressFromServer = '[Associates] Get Address From Server',
  GetAddressFromServerError = '[Associates] Get Address From Server Error',
  GetAddressFromServerSuccess = '[Associates] Get Address From Server Success',
  UpdateAddressOnServer = '[Associates] Update Address On Server',
  UpdateAddressOnServerError = '[Associates] Update Address On Server Error',
  UpdateAddressOnServerSuccess = '[Associates] Update Address On Server Success',
  CreateAddressOnServer = '[Associates] Create Address From Server',
  CreateAddressOnServerError = '[Associates] Create Address From Server Error',
  CreateAddressOnServerSuccess = '[Associates] Create Address From Server Success',
}

//#region message-types
export class GetAddressFromServer implements Action {
  readonly type = AddressEntityActionTypes.GetAddressFromServer;
  constructor(public payload: { params: { associateId: string; sequence: number }; returnAction: any }) {}
}
export class GetAddressFromServerError implements Action {
  readonly type = AddressEntityActionTypes.GetAddressFromServerError;
  constructor(public payload: any) {}
}
export class GetAddressFromServerSuccess implements Action {
  readonly type = AddressEntityActionTypes.GetAddressFromServerSuccess;
  constructor(public payload: Address[]) {}
}

export class UpdateAddressOnServer implements Action {
  readonly type = AddressEntityActionTypes.UpdateAddressOnServer;
  constructor(public payload: { address: Address; queryParams: AddressQueryParameters }) {}
}
export class UpdateAddressOnServerError implements Action {
  readonly type = AddressEntityActionTypes.UpdateAddressOnServerError;
  constructor(public payload: any) {}
}
export class UpdateAddressOnServerSuccess implements Action {
  readonly type = AddressEntityActionTypes.UpdateAddressOnServerSuccess;
  constructor(public payload: Address) {}
}

export class CreateAddressOnServer implements Action {
  readonly type = AddressEntityActionTypes.CreateAddressOnServer;
  constructor(public payload: Address) {}
}
export class CreateAddressOnServerError implements Action {
  readonly type = AddressEntityActionTypes.CreateAddressOnServerError;
  constructor(public payload: any) {}
}
export class CreateAddressOnServerSuccess implements Action {
  readonly type = AddressEntityActionTypes.CreateAddressOnServerSuccess;
  constructor(public payload: Address) {}
}
//#endregion

export type AddressEntityAction =
  | GetAddressFromServer
  | GetAddressFromServerError
  | GetAddressFromServerSuccess
  | UpdateAddressOnServer
  | UpdateAddressOnServerError
  | UpdateAddressOnServerSuccess
  | CreateAddressOnServer
  | CreateAddressOnServerError
  | CreateAddressOnServerSuccess;

export const fromAddressEntityActions = {
  GetAddressFromServer,
  GetAddressFromServerError,
  GetAddressFromServerSuccess,
  UpdateAddressOnServer,
  UpdateAddressOnServerError,
  UpdateAddressOnServerSuccess,
  CreateAddressOnServer,
  CreateAddressOnServerError,
  CreateAddressOnServerSuccess,
};
